import { app } from "./context";

export function exportImage() {
  const link = document.createElement("a");
  link.download = "reaction-diffusion.png";
  link.href = app.renderer.domElement.toDataURL();
  link.click();
  link.remove();
}
